import React, {useCallback, useEffect, useState} from "react";

import "./BookAppointmentComponent.scss";
import {FacilityCarousel} from "./facility-carousel/FacilityCarouselComponent";
import {ImageConfig, Misc} from "../../constants";
import {CommonService} from "../../shared/services";
import {IAPIResponseType} from "../../shared/models/api.model";
import {IClientBasicDetails} from "../../shared/models/client.model";

const BookAppointmentComponent = () => {
    const [facilityWithProvidersDetails, setFacilityWithProvidersDetails] = React.useState<Array<any>>([]);
    const [isFacilityWithProvidersDetailsLoading, setIsFacilityWithProvidersDetailsLoading] = React.useState<boolean>(false);
    const [paymentSuccessParentConfirmation, setPaymentSuccessParentConfirmation] = useState<boolean>(false);


    const fetchAppointmentDetails = useCallback(() => {
        setIsFacilityWithProvidersDetailsLoading(true);
        let initialFacilityWithProvidersDetails: any = [];
        CommonService._bookAppointment.GetFacilityWithProvidersAPICall()
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialFacilityWithProvidersDetails = response.data;
                }
                setFacilityWithProvidersDetails(initialFacilityWithProvidersDetails);
                setIsFacilityWithProvidersDetailsLoading(false);
            }).catch((error: any) => {
            setFacilityWithProvidersDetails(initialFacilityWithProvidersDetails);
            setIsFacilityWithProvidersDetailsLoading(false);
        })
    }, []);

    useEffect(() => {
        fetchAppointmentDetails();
    }, [fetchAppointmentDetails]);

    const UnBlockTheSlotApiCall = useCallback(() => {
        const payload: any = {};
        const storedSessionIds = CommonService._localStorage.getItem("block_session_id");
        if (storedSessionIds) {
            try {
                payload.block_session_id = JSON.parse(storedSessionIds);
            } catch (e) {
                console.error("Failed to parse session IDs from localStorage", e);
            }
        }
        CommonService._bookAppointment.UnBlockMultipleSlotAPICall(payload)
            .then((response: IAPIResponseType<IClientBasicDetails>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
            }).catch((error: any) => {
            CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");
        });
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
            const navType = navEntries[0]?.type;

            // Only trigger for refresh
            if (navType === 'reload') {
                UnBlockTheSlotApiCall()
                e.preventDefault();
                e.returnValue = ''; // Required for Chrome
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [UnBlockTheSlotApiCall]);





    return (
        <div className="facility-slider-container d-flex">
            <div className={'flex-1 pdd-left-70 d-flex flex-direction-column'}>
                <div className="name-logo-avatar pdd-top-10">
                    <img width={107} height={36} src={ImageConfig.BookAppointmentLogo}
                         alt={ImageConfig.BookAppointmentLogo}/>
                </div>
                <div className={'flex-1 d-flex justify-content-center  flex-direction-column'}>
                    <div className={`branding-text ${paymentSuccessParentConfirmation && "display-none"}`}>
                        Choose an <br/>appointment<br/> location.
                    </div>
                    <div
                        className={`branding-minor-text mrg-top-10 ${paymentSuccessParentConfirmation && "display-none"}`}>
                        Select your preferred location to proceed <br/> with scheduling.
                    </div>
                </div>
            </div>
            <div className={`flex-2 book-appointment-carousel ${paymentSuccessParentConfirmation && "display-none"}`}>
                {/* Carousel Component */}
                <FacilityCarousel setPaymentSuccessParentConfirmation={setPaymentSuccessParentConfirmation}
                                  facilityWithProvidersDetails={facilityWithProvidersDetails}
                                  isFacilityWithProvidersDetailsLoading={isFacilityWithProvidersDetailsLoading}/>
            </div>
        </div>
    );
};

export default BookAppointmentComponent;
